import { Component, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Customer_Excel_Interface } from 'src/app/Interface/Customer_Excel_Interface';
import { Customer_List_Interface, Empty_Customer_List_Interface } from 'src/app/Interface/Customer_List_Interface';
import { FeildActivity_Interface } from 'src/app/Interface/FeildActivity_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CustomerService } from 'src/app/Service/Customer/Customer.service';
import { FeildActivityService } from 'src/app/Service/FeildActivity/FeildActivity.service';
import { ProvinceService } from 'src/app/Service/Province/Province.service';

@Component({
  selector: 'app-CustomerListUser',
  templateUrl: './CustomerListUser.component.html',
  styleUrls: ['./CustomerListUser.component.scss']
})
export class CustomerListUserComponent implements OnInit {

  constructor(
    private Customer_Service: CustomerService,
    private Alertify_Service: AlertifyService,
    private province_Service: ProvinceService,
    private FeildActivity_Service: FeildActivityService,
    private modalService: BsModalService
  ) { }
  page: number = 0;
  Procssing: boolean = false

  StartSearchDate: string = ''
  Name: string = ''
  EndSearchDate: string = ''
  SubmitPeriodDate: string = '1'

  ngOnInit() {
    this.Read_Service_Province("")

  }

  DataList_Customer: Array<Customer_List_Interface> = []
  DataList_Customer_Excel: Array<Customer_Excel_Interface> = []
  Data_Seleted_Delete: any

  ReadData_Customer(StartSearchDate, EndSearchDate) {
    this.Procssing = true
    this.StartSearchDate = StartSearchDate
    this.EndSearchDate = EndSearchDate

    this.Customer_Service.GetRecord1(this.ProvinceId,
      this.CityId,
      this.Name,
      '',
      '',
      0,
      Number(this.SubmitPeriodDate),
      0,
      this.FeildActivityId,
      StartSearchDate,
      EndSearchDate,
      false).subscribe(
        data => {
          this.DataList_Customer = data['model']
          this.DataList_Customer_Excel = data['excel']
          this.Procssing = false
        }, error => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )
  }


  current_Month_create: number = 0
  current_Month_update: number = 0
  total: number = 0

  Read_GetDetailCount() {
    this.Customer_Service.GetDetailCount().subscribe(
      data => {
        this.current_Month_create = data['current_Month_create']
        this.current_Month_update = data['current_Month_update']
        this.total = data['total']
      }
    )
  }





  FeildActivityId: string = "0"
  ProvinceId: string = "0"
  CityId: string = "0"


  //#region Province

  DataList_Province: Array<General_Interface> = []
  DataList_City: Array<General_Interface> = []

  Read_Service_Province(id: string) {
    this.province_Service.GetRecord(id).subscribe(
      data => {
        if (id == "") {
          this.DataList_Province = data
          this.ReadData_FeildActivity()
        }
        else {
          this.DataList_City = data
        }
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  ProvinceChange() {
    this.CityId = "0"
    if (this.ProvinceId == "0") {
      this.DataList_City = []
    }
    else {
      this.Read_Service_Province(this.ProvinceId)
    }
  }


  //#endregion


  DataList_FeildActivity: Array<FeildActivity_Interface> = []
  ReadData_FeildActivity() {
    this.FeildActivity_Service.GetRecord().subscribe(
      data => {
        this.DataList_FeildActivity = data
        this.Read_GetDetailCount()

      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }




  Selected_Customer_Record:Customer_List_Interface=Empty_Customer_List_Interface()
  WindowsSwitcher_Indexer:string='List'

  BackToList(){
    this.WindowsSwitcher_Indexer='List'
  }

  setCustomerForEdit(item:Customer_List_Interface)
  {
    this.Selected_Customer_Record=item
    this.WindowsSwitcher_Indexer='Form'
  }

}
